import { alpha, Chip, chipClasses, Stack, styled } from '@mui/material';
import { Fragment } from 'react';
import { DynamicIcon } from 'src/components';
import { ActivityFeed } from 'src/graphql/entities/activity-feed/hooks/use-activity-feed';
import { ActivityFeedTime } from './acitivity-feed-time';
import { ChatActivityContainer } from './chat-activity-container';
import { StyledTypography } from './styled/typography.styled';

const MacroChip = styled(Chip)(({ theme }) => ({
  height: 'auto',
  borderRadius: theme.spacing(2),
  fontSize: '0.75rem',
  fontWeight: 600,
  color: theme.palette.custom.OV.sys.primary,
  backgroundColor: alpha(theme.palette.custom.OV.sys.primary, 0.14),

  [`.${chipClasses.icon}`]: {
    fontSize: '0.75rem',
    width: 'auto',
    height: 'auto',
    color: 'inherit',
  },

  [`.${chipClasses.label}`]: {
    paddingTop: theme.spacing(0.25),
    paddingBottom: theme.spacing(0.25),
  },
}));

const MacroSeparator = styled('span')(({ theme }) => ({
  color: theme.palette.custom.OV.sys.outline,
  fontSize: '0.75rem',
  lineHeight: 1,
}));

export const ExecuteMacroActivityMessage = ({ activity }: { activity: ActivityFeed }) => {
  const executedMacros = activity.changes
    .filter((c) => c.field === 'name' && !!c.value)
    .map((c) => ({ id: c.name, name: c.value! }));

  return (
    <ChatActivityContainer
      icon="bolt"
      title={
        // Wraps because a run can execute more macros than fit the chat's width, and the row this
        // sits in does not wrap on its own.
        <Stack direction="row" alignItems="center" flexWrap="wrap" gap={0.5}>
          <StyledTypography>
            <b>{activity.actor.name}</b> executed{' '}
            {executedMacros.length > 1 ? 'macros' : 'macro'}:
          </StyledTypography>
          {executedMacros.map((macro, index) => (
            <Fragment key={macro.id}>
              {index > 0 && <MacroSeparator aria-hidden>&middot;</MacroSeparator>}
              <MacroChip
                label={macro.name}
                size="small"
                icon={<DynamicIcon name="bolt" weight={500} />}
              />
            </Fragment>
          ))}
          <StyledTypography>
            <ActivityFeedTime activity={activity} />
          </StyledTypography>
        </Stack>
      }
    />
  );
};
